import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/',
      component: () => import('../components/common/Base.vue'),
      meta: {
        title: '公共'
      },
      children: [
        {
          path: '/index',
          component: () => import('../views/home/Home.vue'),
          meta: {
            title: '主页'
          }
        },{
          path: '/employ',
          component: () => import('../views/employ/employs.vue'),
          meta: {
            title: '用户管理'
          }
        },{
          path: '/dept',
          component: () => import('../views/dept/dept.vue'),
          meta: {
            title: '部门管理'
          }
        },{
          path: '/users',
          component: () => import('../views/users/users.vue'),
          meta: {
            title: '人员管理'
          }
        },{
          path: '/outreport',
          component: () => import('../views/outreport/outreport.vue'),
          meta: {
            title: '外出统计'
          }
        },{
          path: '/error',
          component: () => import('../components/page/template/Error.vue'),
          meta: {
            title: '错误路径'
          }
        },
        {
          path: '/404',
          component: () => import('../components/page/template/404.vue'),
          meta: {
            title: '404'
          }
        }
      ]
    },
    {
      path: '/login',
      component: () => import('../views/login/Login.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js